const LIST_SHIPPING_COMPANY_URL = "/v1/shipping-company/list";
const SINGLE_SHIPPING_COMPANY_URL = "/v1/shipping-company/single";
const ADD_SHIPPING_COMPANY_URL = "/v1/shipping-company/add";
const UPDATE_SHIPPING_COMPANY_URL = "/v1/shipping-company/update";
const DELETE_SHIPPING_COMPANY_URL = "/v1/shipping-company/delete";

const SHIPPING_API_URL_LIST = {
    LIST_SHIPPING_COMPANY_URL,
    SINGLE_SHIPPING_COMPANY_URL,
    ADD_SHIPPING_COMPANY_URL,
    UPDATE_SHIPPING_COMPANY_URL,
    DELETE_SHIPPING_COMPANY_URL
}

export { SHIPPING_API_URL_LIST };